function monthDay(year, month) {
    const month2day = [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return month2day[month] || (year % 4 ? 28 : 29);
}
function getDate(...args) {
    if (!args.length || !args[0]) {
        return new Date();
    }
    return new Date(...args);
}

function monthDays() {
    // Get the dates displayed on the calendar for this month 
    const d = getDate(...Array.prototype.slice.call(arguments));
    const year = d.getFullYear();
    const month = d.getMonth();
    const thisMonthDays = monthDay(year, month);
    const lastMonthDays =
        month > 0 ? monthDay(year, month - 1) : monthDay(year - 1, 11);
    const monthFirstDay = new Date(year, month, 1).getDay();
    const prev = monthFirstDay || 7;
    const next = 42 - thisMonthDays - prev;
    var ret = [];
    let iter = prev;
    let prevYear, prevMonth, nextYear, nextMonth;
    if (month == 0) {
        prevYear = year - 1;
        prevMonth = 11;
    } else {
        prevYear = year;
        prevMonth = month - 1;
    }
    if (month == 1) {
        nextYear = year + 1;
        nextMonth = 0;
    } else {
        nextYear = year;
        nextMonth = month + 1;
    }

    while (iter--) {
        ret.push({
            year: prevYear,
            month: prevMonth,
            date: lastMonthDays - iter,
            isPre: true
        });
    }
    iter = 0;
    while (iter < thisMonthDays) {
        ret.push({ year, month, date: ++iter });
    }
    iter = 0;
    while (iter < next) {
        ret.push({
            year: nextYear,
            month: nextMonth,
            date: ++iter,
            isNext: true
        });
    }
    let arr = [],
        i = 0;
    while (i < 6) {
        arr.push(ret.slice(i++ * 7, i * 7));
    }
    return arr;
}

export default {
    monthDays
};
